import { setView } from "components/common/Filters/Filters.slice";
import {
  setCorpViewSelectedTab,
  setSelectedList,
  setSelectedListCategory
} from "components/features/Corp/CorpUser.Slice";
import { store } from "redux/store";
import colors from "styles/Colors";
import { DISPLAY_TYPE } from "utils/CommonConstants";
import { routes } from "utils/routes";
import BookmarkPlansProperties from "../BookmarkPlansProperties";
import { TAB } from "../BookmarkPlansProperties/TAB";

export const bookmarkedHandleClick = (indexValue: number) => {
  const state: any = store.getState();
  const savedFiltersAndLists: any = state.filters.savedFilter;
  store.dispatch(setView("myList"));
  store.dispatch(setSelectedListCategory("bookmarked"));
  store.dispatch(setSelectedList(savedFiltersAndLists["bookmarked"]?.[indexValue]));
  store.dispatch(setCorpViewSelectedTab({ type: "myList", val: indexValue }));
};

export const Config = {
  [DISPLAY_TYPE.bookmarkedPropertiesPlans]: {
    themeBG: "light",
    color: colors.Neutral.Neutral0,
    title: "Bookmarked",
    targetURL: (navigate: any) => {},
    buttonVariant: "outlined",
    tabs: [
      {
        label: "Properties",
        content: Hoc(BookmarkPlansProperties, TAB.properties)
      },
      {
        label: "Plans",
        content: Hoc(BookmarkPlansProperties, TAB.plans)
      }
    ],
    buttons: [
      {
        label: "View Full List",
        targetURL: (navigate: any) => {
          navigate(routes.MyLists);
          bookmarkedHandleClick(0);
        }
      },
      {
        label: "View Full List",
        targetURL: (navigate: any) => {
          navigate(routes.MyLists);
          bookmarkedHandleClick(1);
        }
      }
    ]
  }
};

function Hoc(WrappedComponent: any, tab: string) {
  return function (props: any) {
    return <WrappedComponent {...props} tab={tab} />;
  };
}
